import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

const INCLUDED = [
  ["Pages, responsive build, launch", "Included"],
  ["Domain + hosting set up with you", "At cost"],
  ["A little help finding the words", "Optional"],
  ["Aftercare — small edits kept free", "Included"],
];

export const Practical = () => (
  <section id="pricing" data-testid="pricing-section" className="px-5 py-24 sm:px-8 sm:py-32 lg:px-10">
    <div className="mx-auto max-w-7xl">
      <Chapter n="04" label="The practical bit" />

      <div className="mt-10 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="max-w-[680px] font-display text-4xl font-bold leading-[1.0] tracking-[-0.04em] sm:text-6xl">
              A credible web presence should not need a{" "}
              <span className="text-[#7650c7]">finance meeting.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-12 flex items-end gap-5">
              <p data-testid="price-display" className="font-display text-7xl font-bold leading-none tracking-[-0.05em] sm:text-8xl">
                £250<span className="text-[#7650c7]">+</span>
              </p>
              <p className="mb-2 max-w-[180px] font-mono text-[11px] uppercase leading-relaxed tracking-[0.18em] text-[#6d687c]">
                Core websites start from
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-8 max-w-[540px] text-base leading-relaxed text-[#6d687c] sm:text-lg">
              Every project is quoted individually based on the pages, content and
              functionality you need, so you know exactly what is included before any work
              begins.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <button
              data-testid="pricing-cta-quote"
              onClick={() => scrollToSection("#contact")}
              className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[#7650c7] px-6 py-3.5 text-sm font-semibold text-[#f3f0e8] transition-transform duration-300 hover:-translate-y-1"
            >
              Get a considered quote
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="flex h-full flex-col rounded-[1.5rem] border border-[#201e32]/10 bg-white p-7 sm:p-9">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-[#7650c7]">
              Your quote, clearly
            </p>
            <p className="mt-5 text-sm leading-relaxed text-[#6d687c]">
              We keep our projects small, focused and quote-by-quote. You always know what is
              included, what is optional and what happens next.
            </p>
            <ul className="mt-7 flex flex-col">
              {INCLUDED.map(([item, tag], i) => (
                <li
                  key={item}
                  data-testid={`pricing-included-${i + 1}`}
                  className="flex items-center justify-between gap-4 border-t border-[#201e32]/10 py-4 text-sm"
                >
                  <span className="flex items-center gap-3 font-medium">
                    <Check size={15} className="shrink-0 text-[#7650c7]" aria-hidden />
                    {item}
                  </span>
                  <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.14em] text-[#6d687c]">
                    {tag}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-auto pt-7 font-mono text-[10px] uppercase tracking-[0.2em] text-[#201e32]/40">
              Most sites live within 7 days
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
